import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "table table-hover" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { "data-test": "team-member-numbers" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

import { GroupAndMembersApiModel, OrganisationAndMembersApiModel } from "../../../api-models";
import TeamsOrGroups from "../../../typings/enums/teams-or-groups";


export default /*#__PURE__*/_defineComponent({
  __name: 'teams-tab',
  props: {
    id: {},
    model: {},
    sortedTeams: {},
    canCreateGroupsAndTeams: { type: Boolean }
  },
  emits: ["add-groups"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function pluralEnding(count: number, singular = "", plural = "s"): string {
  return count === 1 ? singular : plural;
}

function countOfGroupMembersOutsideOrganisation(groupAndMembers: GroupAndMembersApiModel): number {
  return groupAndMembers?.members.filter((m) => (m.organisation?.id || null) !== props.model?.id)
    .length;
}

function addGroups(payload: TeamsOrGroups): void {
  emit("add-groups", payload);
}

return (_ctx: any,_cache: any) => {
  const _directive_data_table = _resolveDirective("data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, [
      _createTextVNode(" Teams "),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addGroups(_unref(TeamsOrGroups).Teams))),
        class: "btn btn-sm btn-primary pull-right",
        style: {"margin-left":"20px"},
        type: "button"
      }, " Include existing teams... "),
      (_ctx.canCreateGroupsAndTeams)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: '/admin/group/create?organisationId=' + _ctx.id,
            class: "btn btn-sm btn-primary pull-right",
            style: {"margin-left":"20px"}
          }, "Create new group/team...", 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedTeams, (team) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: team.group.id
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("a", {
                href: '/admin/group/details/' + team.group.id,
                target: "_blank",
                rel: "noopener noreferrer",
                "data-test": "team-name-link"
              }, _toDisplayString(team.group.name), 9, _hoisted_5)
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createTextVNode(_toDisplayString(team.members.length) + " member" + _toDisplayString(pluralEnding(team.members.length)) + " ", 1),
              (countOfGroupMembersOutsideOrganisation(team))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(countOfGroupMembersOutsideOrganisation(team)) + " external)", 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_8
          ]))
        }), 128))
      ])
    ])), [
      [_directive_data_table, 
        _ctx.sortedTeams.length && {
          paging: false,
          searching: true,
          info: false,
          columnDefs: [{ targets: 2, orderable: false }],
          order: [[0, 'asc']],
        }
      ]
    ])
  ]))
}
}

})